import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import type { StepperStepState } from "./Stepper.types";

export const StepperList = styled.ol`
  display: flex;
  align-items: center;
  gap: ${spacing[3]};
  margin: 0;
  padding: 0;
  list-style: none;
  width: 100%;
`;

export const StepItem = styled.li<{ $last: boolean }>`
  display: flex;
  align-items: center;
  gap: ${spacing[3]};
  flex: ${({ $last }) => ($last ? "0 0 auto" : "1 1 0")};
  min-width: 0;
`;

export const StepMarker = styled.span<{ $state: StepperStepState }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  box-sizing: border-box;
  ${typographyMixin("body", 3)}
  font-weight: 600;
  color: ${({ $state }) =>
    $state === "current" ? rawColors.structural.white : $state === "done" ? rawColors.brand.primary : rawColors.text.lowEmphasis};
  background: ${({ $state }) =>
    $state === "current" ? rawColors.brand.primary : $state === "done" ? rawColors.accent.purpleLight : rawColors.structural.white};
  border: 1px solid ${({ $state }) => ($state === "todo" ? rawColors.stroke[200] : "transparent")};

  svg {
    width: 0.75rem;
    height: 0.75rem;
  }
`;

export const StepText = styled.span`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const StepLabel = styled.span<{ $state: StepperStepState }>`
  ${typographyMixin("body", 3)}
  font-weight: 600;
  color: ${({ $state }) => ($state === "todo" ? rawColors.text.lowEmphasis : rawColors.text.highEmphasis)};
  white-space: nowrap;
`;

export const StepDetail = styled.span`
  ${typographyMixin("body", 3)}
  color: ${rawColors.text.lowEmphasis};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StepLine = styled.span`
  flex: 1 1 auto;
  min-width: 1rem;
  height: 1px;
  background: ${rawColors.stroke[200]};
`;

export const HiddenState = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
`;
